import { State } from 'modules';

import { getEnumValues } from 'utils/helper';

import { APIUserRight, APIUserTenant, APIUserType } from 'types/api';

export const user = (state: State) => state.app?.user;
export const selectedTenant = (state: State) =>
  state.app?.user?.userTenants?.find(it => it.isSelected);

export const userId = (state: State) => state.app?.user?.id;

export const userType = (state: State) => state.app?.user?.userType;

export const tenantId = (state: State) =>
  state.app?.user?.userTenants?.find(it => it.isSelected)?.tenant.id ?? '';

export const currentTenant = (state: State) =>
  state.app?.user?.userTenants?.find(it => it.isSelected)?.tenant;

export const tenants = (state: State) =>
  state.app.user?.userTenants as APIUserTenant[];

export const isAppLoaded = (state: State) => state.app.isAppLoaded;
export const userInfoPending = (state: State) => state.app.userInfoPending;
export const userLoginInPending = (state: State) =>
  state.app.userLoginInPending;

export const isNavigationCollapsed = (state: State) =>
  state.app.isNavigationCollapsed;

export const userRegisterPending = (state: State) =>
  state.app.userRegisterPending;

export const isAdminUser = (state: State) => {
  const userType = state.app?.user?.userTenants?.find(
    it => it.isSelected,
  )?.userType;

  return userType === APIUserType.Admin;
};

export const tenantUserType = (state: State) => {
  const userType = state.app?.user?.userTenants?.find(
    it => it.isSelected,
  )?.userType;
  return userType ?? APIUserType.User;
};

export const tenantUserRights = (state: State) => {
  const tenant = state.app?.user?.userTenants?.find(it => it.isSelected);

  const userType = tenant?.userType;
  const userRights = tenant?.userRights;

  if (!userType) {
    return [];
  }

  return userType == APIUserType.Admin
    ? getEnumValues(APIUserRight)
    : userRights?.map(it => it.right);
};

export const updateAvatarPending = (state: State) =>
  state.app.updateAvatarPending;

export const updateSelfInfoPending = (state: State) =>
  state.app.updateSelfInfoPending;
